module.exports = __webpack_public_path__ + "img/aldebert.bccb3ac1.jpg";